import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface OtpState {
  otp: string[];
  errorMessage: string;
  otpLoader: boolean;
  otp_id:string
}

const initialState: OtpState = {
  otp: new Array(6).fill(""),
  errorMessage: "",
  otpLoader: false,
  otp_id: ''
};

const otpSlice = createSlice({
  name: "otp",
  initialState,
  reducers: {
    resetOtp: (state) => {
      state.otp = new Array(6).fill("");
      state.errorMessage = "";
    },
    setOtp: (state, action: PayloadAction<{ otp: string[] }>) => {
      state.otp = action.payload.otp;
    },
    setErrorMessage: (state, action: PayloadAction<string>) => {
      state.errorMessage = action.payload;
    },
    setOtpLoader: (state, action: PayloadAction<boolean>) => {
      state.otpLoader = action.payload;
    },
    setOTPid: (state, action: PayloadAction<string>) => {
      state.errorMessage = action.payload;
    },
    submitOtp: (state) => {
      // Logic to handle OTP submission can go here (e.g., API call)
      console.log("Submitting OTP:", state.otp.join(""));
    },
  },
});

export const { setOtp, setErrorMessage, submitOtp, setOTPid, resetOtp, setOtpLoader } = otpSlice.actions;
export default otpSlice.reducer;
